import {
	AddCircle,
	ContentCopyRounded,
	DoDisturbOn,
	EditOutlined,
	NotificationsActive,
} from "@mui/icons-material";
import {
	Avatar,
	Box,
	IconButton,
	ImageListItem,
	ImageListItemBar,
	Stack,
	Switch,
	Tooltip,
	Typography,
} from "@mui/material";
import MUIDataTable from "mui-datatables";
import { RemoveRedEye } from "@mui/icons-material";

import { useEffect, useMemo, useRef, useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toast } from "react-toastify";
import { getAllPlayoffs } from "../../../../apis/Playoff";
import PinToTopPlayoff from "../../../../components/Playoff/PinToTopPlayoff";

import { debounce } from "lodash";
import NotificationModal from "../../../../components/Playoff/NotificationModal";

export const notify = (m) =>
	toast.success(m, {
		position: "top-right",
		autoClose: 2500,
		hideProgressBar: false,
		closeOnClick: true,
		// pauseOnHover: true,
		draggable: true,
		progress: undefined,
	});
export default function DataTable({ user }) {
	const [data, setData] = useState([]);
	const [page, setPage] = useState(0);
	const [filters, setFilters] = useState({ allowed_to_cart: true });
	const [rowsCount, setRowsCount] = useState(10);
	const [count, setCount] = useState(0);

	const [playoff, setPlayoff] = useState(null);
	const pendingPlayoffRef = useRef(null);
	const [open, setOpen] = useState(false);
	const [message, setMessage] = useState("");
	useEffect(() => {
		getAllPlayoffs(rowsCount, page + 1, filters).then((res) => {
			setData(res.results);
			setCount(res.count);
		});
	}, [page, rowsCount, filters]);

	const columns = [
		{
			name: "id",
			label: "Id",
			options: {
				filter: false,
				sort: true,
				setCellProps: () => ({ sx: { textAlign: "right" } }),
				// customBodyRender: (value, tableMeta, updateValue) => {
				// 	// console.log("yes", tableMeta);
				// 	return tableMeta.rowIndex + 1;
				// },
			},
		},
		{
			name: "slug",
			label: "Slug",
			options: {
				filter: false,
				sort: true,
				// setCellProps: () => ({ sx: { textAlign: "right" } }),
				// customBodyRender: (value, tableMeta, updateValue) => {
				// 	// console.log("yes", tableMeta);
				// 	return tableMeta.rowIndex + 1;
				// },
				customBodyRender: (value) => {
					return (
						<Box
							sx={{
								display: "flex",
								flexDirection: "row",
								alignItems: "center",
							}}
						>
							<Typography variant="p" component={"p"}>
								{value}
							</Typography>

							<CopyToClipboard
								text={value}
								onCopy={() => notify("copied")}
							>
								<IconButton size="small" color="primary">
									<ContentCopyRounded />
								</IconButton>
							</CopyToClipboard>
						</Box>
					);
				},
			},
		},
		{
			name: "title",
			label: "Title",
			options: {
				filter: false,
				sort: true,
				customBodyRender: (value) => {
					return (
						<Box
							sx={{
								display: "flex",
								flexDirection: "row",
								alignItems: "center",
							}}
						>
							<Typography variant="p" component={"p"}>
								{value}
							</Typography>

							<CopyToClipboard
								text={value}
								onCopy={() => notify("copied")}
							>
								<IconButton size="small" color="primary">
									<ContentCopyRounded />
								</IconButton>
							</CopyToClipboard>
						</Box>
					);
				},
			},
		},
		{
			name: "description",
			label: "Description",
			options: {
				filter: false,
				// sort: true,
				setCellProps: () => ({ style: { width: 150, maxWidth: 150 } }),
				customBodyRender: (value) => {
					return (
						<Box
							sx={{
								display: "flex",
								flexDirection: "row",
								alignItems: "center",
							}}
						>
							<Tooltip
								componentsProps={{
									tooltip: {
										sx: {
											bgcolor: "white",
											color: "black",
											boxShadow: 2,
											fontSize: 14,
										},
									},
									arrow: {
										sx: {
											color: "white", // This sets the arrow color to match the tooltip background
										},
									},
								}}
								title={value}
								arrow
								placement="top"
							>
								<Typography
									variant="body2"
									sx={{
										display: "-webkit-box",
										WebkitLineClamp: 3,
										WebkitBoxOrient: "vertical",
										overflow: "hidden",
										textOverflow: "ellipsis",
									}}
								>
									{value}
								</Typography>
							</Tooltip>

							<CopyToClipboard
								text={value}
								onCopy={() => notify("copied")}
							>
								<IconButton size="small" color="primary">
									<ContentCopyRounded />
								</IconButton>
							</CopyToClipboard>
						</Box>
					);
				},
			},
		},

		{
			name: "image",
			label: "Collage",
			options: {
				filter: false,
				sort: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					// console.log("yes", value);
					return (
						<Avatar
							alt="List Logo"
							variant="square"
							sx={{
								width: 100,
								height: 100,
								objectFit: "fill",
							}}
							src={value?.file}
						/>
					);
				},
			},
		},

		{
			name: "list_category",
			label: "List Category",
			options: {
				filter: false,
				sort: true,
				customBodyRender: (value, tableMeta, updateValue) => {
					// console.log("yes", value);
					return value.map((p, i) => (
						<Typography
							component={"p"}
							variant="p"
							key={`list-${i}`}
						>
							{p.name}
						</Typography>
					));
				},
			},
		},

		{
			name: "prize",
			label: "Prize",
			options: {
				filter: true,
				sort: true,
				display: "true",
				filterType: "custom",
				// customFilterListOptions: {
				// 	update: (filterList, filterPos, index) => {
				// 		// console.log("update");
				// 		// console.log(filterList, filterPos, index);
				// 		return filterList;
				// 	},
				// },

				customBodyRender: (value, tableMeta, updateValue) => {
					return value ? (
						<ImageListItem>
							<Avatar
								alt="List Logo"
								variant="square"
								sx={{
									width: 100,
									height: 100,
									objectFit: "fill",
								}}
								src={value?.image}
							/>
							<ImageListItemBar
								// sx={{
								// 	background:
								// 		"linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, " +
								// 		"rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)",
								// }}
								title={value.title}
								position="below"
							/>
						</ImageListItem>
					) : null;
				},
			},
		},
		{
			name: "Playoff Date & Time",
			label: "Playoff Date & Time",
			options: {
				filter: false,
				sort: true,
				customBodyRender: (value, tableMeta, updateValue) => {
					const row = data[tableMeta.rowIndex];
					return (
						<>
							{new Date(row.play_off_start_date_time)
								.toString()
								.substring(4, 24)}{" "}
							-{" "}
							{new Date(row.play_off_end_date_time)
								.toString()
								.substring(4, 24)}
						</>
					);
					// console.log("yes", value);
				},
			},
		},

		{
			name: "active",
			label: "Toggles",
			options: {
				filter: false,
				sort: true,
				customBodyRender: (value, tableMeta, updateValue) => {
					const playoff = data[tableMeta.rowIndex];
					return (
						<Stack direction={"column"}>
							<Stack
								direction={"row"}
								justifyContent={"center"}
								alignItems={"center"}
								sx={{
									border: "1px solid",
									borderColor: "divider", // uses theme.palette.divider
									borderRadius: 2, // optional
									p: 1,
								}}
							>
								<Typography>Active </Typography>
								<Switch
									checked={playoff.active}
									onChange={(e) => {
										e.preventDefault();
									}}
									inputProps={{
										"aria-label": "controlled",
									}}
								/>
							</Stack>
							<Stack
								direction={"row"}
								justifyContent={"center"}
								alignItems={"center"}
								sx={{
									border: "1px solid",
									borderColor: "divider", // uses theme.palette.divider
									borderRadius: 2, // optional
									p: 1, // optional padding
									my: 1,
								}}
							>
								<Typography>For Playoff</Typography>
								<Switch
									checked={playoff.is_active}
									onChange={(e) => {
										e.preventDefault();
									}}
									inputProps={{
										"aria-label": "controlled",
									}}
								/>
							</Stack>
							<Stack
								direction={"row"}
								justifyContent={"center"}
								alignItems={"center"}
								sx={{
									border: "1px solid",
									borderColor: "divider", // uses theme.palette.divider
									borderRadius: 2, // optional
									p: 1, // optional padding
								}}
							>
								<Typography>Pin to Top</Typography>
								<PinToTopPlayoff row={playoff} />
							</Stack>
						</Stack>
					);
				},
			},
		},

		{
			name: "",
			label: "Action",
			options: {
				filter: false,
				sort: true,
				viewColumns: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					const row = data[tableMeta.rowIndex];
					return (
						<Box>
							<IconButton
								color="primary"
								onClick={() => {
									const playoff = {
										id: row.id,
										title: row.title,
										retire: row.retire,
										notify: true,
									};
									pendingPlayoffRef.current = playoff;
									setPlayoff(playoff);

									setOpen(true);
									setMessage(
										`Do you want to send notification to Playoff ${row?.title} `
									);
								}}
							>
								<NotificationsActive />
							</IconButton>
							<IconButton
								color="primary"
								href={
									user.user_type === 4
										? `/upload-playoff/cart/playoff/${row.id}/edit/`
										: `/w86zjruk6q/cart/playoff/${row.id}/edit/`
								}
							>
								<EditOutlined />
							</IconButton>
							<IconButton
								color="primary"
								href={`/w86zjruk6q/cart/playoff/${row.id}/`}
							>
								<RemoveRedEye />
							</IconButton>
							<CopyToClipboard
								text={`https://www.grape.town/playoff/${row.slug}`}
								onCopy={() => notify("copied")}
							>
								<IconButton size="small" color="primary">
									<ContentCopyRounded />
								</IconButton>
							</CopyToClipboard>

							<IconButton
								size="small"
								color={row.retire ? "primary" : "secondary"}
								onClick={() => {
									const playoff = {
										id: row.id,
										title: row.title,
										retire: !row.retire,
										notify: false,
									};
									pendingPlayoffRef.current = playoff;
									setPlayoff(playoff);
									setOpen(true);
									setMessage(
										`Do you want to engage Playoff ${row?.title}'s curations`
									);
								}}
							>
								{row.retire ? <AddCircle /> : <DoDisturbOn />}
							</IconButton>
						</Box>
					);
				},
			},
		},
	];

	const handleSearchChange = useMemo(
		() => debounce((searchText) => {
			setFilters((currentFilters) => ({
				...currentFilters,
				title: searchText,
			}));
		}, 500),
		[]
	);

	const options = {
		jumpToPage: true,
		selectableRows: "none",
		download: false,
		filterType: "multiselect",
		filter: false,
		serverSide: true,
		print: false,
		count: count,
		page: page,
		rowsPerPage: rowsCount,
		rowsPerPageOptions: [10, 25, 100],
		onChangePage(currentPage) {
			setPage(currentPage);
		},
		onChangeRowsPerPage(numberOfRows) {
			setRowsCount(numberOfRows);
		},
		onSearchChange: handleSearchChange,
		// onColumnSortChange: (changedColumn, direction) => {
		// 	setSortingValues(
		// 		direction === "desc" ? `-${changedColumn}` : `${changedColumn}`
		// 	);
		// 	// setPage(0)
		// 	// setSortFields(temp);
		// },
		// onFilterChange: (columnChanged, filterList, type, index) => {
		// 	setPage(0);
		// 	let value = filterList[index];
		// 	let filterdata = {};
		// 	let newar = [];
		// 	if (columnChanged === "playoff") {
		// 		newar = playoffs
		// 			.filter(({ title }) => value.includes(title))
		// 			.map((play) => play.id);

		// 		filterdata[columnChanged] = newar;
		// 		setFilters({ ...filters, ...filterdata });
		// 	} else if (columnChanged === "owner") {
		// 		newar = owner
		// 			.filter(({ name }) => value.includes(name))
		// 			.map((play) => play.id);

		// 		filterdata[columnChanged] = newar;
		// 		setFilters({ ...filters, ...filterdata });
		// 	}
		// },

		// onTableChange: (action, tableState) => {
		// 	switch (action) {
		// 		case "sort":
		// 			sortTable(tableState.page, tableState.sortOrder);
		// 			break;
		// 		default:
		// 			console.log("action not handled.");
		// 	}
		// },
	};

	useEffect(() => {
		if (!open) {
			setMessage("");
			const pendingPlayoff = pendingPlayoffRef.current;
			if (pendingPlayoff) {
				setData((currentData) =>
					currentData.map((p) =>
						p.id === pendingPlayoff.id
							? { ...p, retire: pendingPlayoff.retire }
							: p
					)
				);
			}
			pendingPlayoffRef.current = null;
			setPlayoff(null);
		}
	}, [open]);

	return (
		<>
			<Box>
				<MUIDataTable
					title={"Playoffs"}
					data={data}
					columns={columns}
					options={options}
				/>
			</Box>

			<NotificationModal
				playoff={playoff}
				setOpen={setOpen}
				open={open}
				msg={message}
			/>
		</>
	);
}
